import Typography from '@mui/material/Typography';
import { useMuiMediaQuery } from '../../../../../utilities/hooks';

interface SecondaryHeaderProps {
    children: React.ReactNode;
}

const QuestionPageSecondaryHeader = ({ children }: SecondaryHeaderProps) => {
    const { isMobile } = useMuiMediaQuery();
    return (
        <Typography component="h2" variant={isMobile ? 'h6' : 'h5'} color="textPrimary">
            {children}
        </Typography>
    );
};

export default QuestionPageSecondaryHeader;
